/**
 * Suivi d'un export CSV en une seule requête : étapes (extraction serveur, réception, mise en
 * forme) et chronomètre, affichés par le composant Global/ExportProgress.
 *
 * Utilisé par la facturation automatique et la page Extraction.
 */
export default {
  data() {
    return {
      exportLoading: false,
      exportSteps: [],
      exportElapsed: 0, // millisecondes
      exportStartedAt: 0,
      exportTimer: null,
      // Une requête relancée (ou une modale fermée) invalide les réponses de la précédente
      exportRequestId: 0,
    };
  },
  computed: {
    exportElapsedLabel() {
      return (this.exportElapsed / 1000).toFixed(1).replace(".", ",") + " s";
    },
  },
  beforeDestroy() {
    this.stopExportTimer();
  },
  methods: {
    /**
     * Démarre le suivi : trois étapes à venir et le chronomètre.
     *
     * @param {string} extractLabel libellé de l'étape serveur
     */
    startExportProgress(extractLabel) {
      this.exportSteps = [
        { key: "extract", label: extractLabel, state: "pending", detail: null },
        { key: "download", label: "Réception des données", state: "pending", detail: null },
        { key: "format", label: "Préparation du fichier CSV", state: "pending", detail: null },
      ];
      this.stopExportTimer();
      this.exportElapsed = 0;
      const startedAt = Date.now();
      this.exportTimer = setInterval(() => {
        this.exportElapsed = Date.now() - startedAt;
      }, 100);
      this.exportStartedAt = startedAt;
    },
    setExportStep(key, state, detail) {
      const step = this.exportSteps.find((item) => item.key === key);
      if (step) {
        step.state = state;
        if (detail !== undefined) {
          step.detail = detail;
        }
      }
    },
    /** L'étape en cours passe en erreur (requête échouée). */
    failExportStep() {
      const active = this.exportSteps.find((step) => step.state === "active");
      if (active) {
        active.state = "error";
      }
    },
    stopExportTimer() {
      if (this.exportTimer) {
        clearInterval(this.exportTimer);
        this.exportTimer = null;
        this.exportElapsed = Date.now() - this.exportStartedAt;
      }
    },
    resetExportProgress() {
      this.stopExportTimer();
      ++this.exportRequestId;
      this.exportSteps = [];
      this.exportElapsed = 0;
    },
    /** Callback axios : premier octet reçu, le serveur a fini d'extraire. */
    exportDownloadProgress(requestId) {
      return (event) => {
        if (requestId !== this.exportRequestId) {
          return;
        }
        this.setExportStep("extract", "done");
        this.setExportStep("download", "active", this.formatBytes(event.loaded) + " reçus");
      };
    },
    formatBytes(bytes) {
      return bytes >= 1048576
        ? (bytes / 1048576).toFixed(1).replace(".", ",") + " Mo"
        : Math.round(bytes / 1024) + " Ko";
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/exportProgress.js